import { render } from "./quizPublico.vue?vue&type=template&id=3e43f296&scoped=true"
import script from "./quizPublico.vue?vue&type=script&lang=js"
export * from "./quizPublico.vue?vue&type=script&lang=js"

import "./quizPublico.vue?vue&type=style&index=0&id=3e43f296&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e43f296"]])

export default __exports__